import { B2BProducts, AuthFlowType, StytchB2BUIConfig, B2BOAuthProviders } from '@stytch/nextjs/b2b'
import { STYTCH_ACTIVE_SESSION_DURATION, getSharedRedirectURL } from './config'

const STYTCH_PATIENT_EMAIL_TEMPLATE_IDS = {
  login: 'patient_portal_login',
  invite: 'patient_portal_registration',
}

export const getOrganizationConfig = (): StytchB2BUIConfig => {
  const redirectURL = getSharedRedirectURL()

  return {
    products: [B2BProducts.emailMagicLinks, B2BProducts.oauth],
    sessionOptions: { sessionDurationMinutes: STYTCH_ACTIVE_SESSION_DURATION },
    emailMagicLinksOptions: {
      loginRedirectURL: redirectURL,
      signupRedirectURL: redirectURL,
      loginTemplateId: STYTCH_PATIENT_EMAIL_TEMPLATE_IDS.login,
      signupTemplateId: STYTCH_PATIENT_EMAIL_TEMPLATE_IDS.invite,
    },
    oauthOptions: {
      loginRedirectURL: redirectURL,
      signupRedirectURL: redirectURL,
      discoveryRedirectURL: redirectURL,
      providers: [B2BOAuthProviders.Google],
    },
    authFlowType: AuthFlowType.Organization,
  }
}
